import {
    Dialog, DialogContent, DialogTitle, Grid,
} from '@mui/material';
import {
    Field, Formik, FormikHelpers, FormikProps,
} from 'formik';
import React, { useState } from 'react';
import axios from 'axios';
import API from '../../utils/API';
import { getJsonPath } from '../../utils/constants';
import { persistLogin } from '../../utils/localStorage';
import useStore from '../../store/store';
import { isValidFunction } from '../../utils/nullChecks';
import { Store } from '../../store/types';
import { MapKV } from '../../types/commonTypes';
import ActionButton from '../ActionButton/ActionButton';
import { useCommonMessageAndSpinnerHandlers } from '../../hooks';
import { FormikTextField } from '../Formik';

type FormProps = {
    errorMsg: string,
};

const SessionTimeoutDialogForm = (props: FormProps & FormikProps<MapKV>) => {
    console.log(props);
    const {
        errorMsg,
        submitForm,
    } = props;
    const sessionTimeout = useStore((state: Store) => state.sessionTimeout);
    const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
        if (event.key === 'Enter') {
            submitForm();
        }
    };
    return (
        <Dialog
            open={sessionTimeout?.timeout || false}
            maxWidth="sm"
            disableRestoreFocus
        >
            <DialogTitle>
                <div
                    style={{
                        height: '200px',
                        display: 'flex',
                        alignItems: 'center',
                    }}
                >
                    <img
                        src={getJsonPath('/Session_Timed_Out.svg')}
                        alt="Session Timed Out"
                        width="200px"
                        height="100px"
                    />
                    <h3>
                        Your session has expired due to inactivity
                    </h3>
                </div>

            </DialogTitle>

            <DialogContent>
                <Grid
                    container
                    sx={{
                        paddingTop: '3rem',
                    }}
                    spacing={3}
                    justifyContent="center"
                >
                    <Grid item sm={10}>
                        <Field
                            component={FormikTextField}
                            name="username"
                            label="Username"
                            fullWidth
                            autoFocus
                            onKeyDown={handleKeyDown}
                        />
                    </Grid>
                    <Grid item sm={10}>

                        <Field
                            component={FormikTextField}
                            label="Password"
                            type="password"
                            name="password"
                            fullWidth
                            onKeyDown={handleKeyDown}
                        />
                    </Grid>
                    <Grid
                        item
                        sm={10}
                        md={10}
                        lg={10}
                        style={{
                            textAlign: 'left',
                        }}
                    >
                        <span style={{
                            color: 'red',
                            marginLeft: 2,
                            fontSize: 14,
                            backgroundColor: errorMsg ? '#F9EAEC' : '',
                            borderRadius: 8,
                            display: 'block',
                            padding: '8px',
                        }}
                        >
                            {' '}
                            {errorMsg}
                            {' '}
                        </span>
                    </Grid>
                    <Grid item sm={10} container justifyContent="flex-end">
                        <ActionButton
                            variant="contained"
                            onClick={submitForm}
                        >
                            Login
                        </ActionButton>
                    </Grid>

                </Grid>
            </DialogContent>
        </Dialog>
    );
};
type Props = {};
const SessionTimeoutDialog = (props: Props) => {
    const [errorMsg, seterrorMsg] = useState<string>('');
    const setSessionTimeout = useStore((state: Store) => state.setSessionTimeout);
    const sessionTimeout = useStore((state: Store) => state.sessionTimeout);
    const commonHandlers = useCommonMessageAndSpinnerHandlers();
    const { showSpinner, hideSpinner } = commonHandlers;
    console.log(props);
    const handleSubmit = async (values: MapKV, helpers: FormikHelpers<MapKV>) => {
        showSpinner();
        console.log('onloginSubmit', values);
        const { username, password } = values;
        if (!username || !password) {
            seterrorMsg('Username or password not entered');
        } else {
            try {
                const resp = await axios.post(`${API.AUTH.LOGIN}`, values);
                if (resp.status === 200) {
                    persistLogin(resp.data);
                    if (isValidFunction(sessionTimeout?.successCallback)) {
                        sessionTimeout?.successCallback!();
                    }
                    setSessionTimeout({ timeout: false });
                    const { resetForm } = helpers;
                    resetForm();
                }
            } catch (error) {
                console.log('loginerrror', error);
                seterrorMsg('Username or password is wrong');
            }
        }
        hideSpinner();
    };
    // eslint-disable-next-line react/no-unstable-nested-components
    const SessionTimeoutDialogFormComp = (innerProps: FormikProps<MapKV>) => (
        <SessionTimeoutDialogForm {...innerProps} errorMsg={errorMsg} />
    );
    return (
        <Formik
            initialValues={{}}
            onSubmit={handleSubmit}
            component={SessionTimeoutDialogFormComp}
        />
    );
};

export default SessionTimeoutDialog;
